import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { Action, NavigationType, UserPermissions } from '@shared-libs/enums';
import { NavigationService } from '@shared-services/navigation.service';
import { MessageService } from '@shared-services/message.service';
import { IDataQuery, TableDesktopComponent } from '@beego/ngx-table';
import { ClientProvider } from '@internal-providers/client.provider';
import { IClient } from '@internal-models/client.model';
import { InternalNavigationType } from '@shared-directives/navigate.directive';
import { ActivatedRoute } from '@angular/router';
import { ClientTableFactory } from '@internal-factories/tables/clients-table.factory';
import { CreateClientComponent } from '@internal-components/client-components/create-client-component/create-client.component';
import { StatisticProvider } from '@internal-providers/statistic.provider';
import { translate } from '@shared-libs/helpers';
import { UserManager } from '@shared-managers/user.manager';
@Component({
	selector: 'clients-desktop-page',
	templateUrl: 'clients.desktop.page.html',
	styleUrls: ['./clients.desktop.page.scss'],
})
export class ClientsDesktopPage implements AfterViewInit {
	@ViewChild(TableDesktopComponent) private readonly tableComponent: TableDesktopComponent;

	public clients: Array<IClient> = new Array();

	public readonly tableHeaders = ClientTableFactory.getHeaders();
	public readonly tableFilters = ClientTableFactory.getFilters();
	public readonly InternalNavigationType: typeof InternalNavigationType = InternalNavigationType;
	public readonly UserPermissions: typeof UserPermissions = UserPermissions;

	constructor(
		private readonly provider: ClientProvider,
		private readonly navigationService: NavigationService,
		private readonly messageService: MessageService,
		private readonly route: ActivatedRoute,
		private readonly statisticProvider: StatisticProvider,
		private readonly userManager: UserManager
	) {}

	public readonly dataRequest = (query: IDataQuery) => this.provider.getAll(query);

	public dataChanged(clients: Array<IClient>): void {
		this.clients = clients;
	}

	public ngAfterViewInit(): void {
		this.route.url.subscribe(() => {
			this.tableComponent?.refreshData();
		});
	}

	public async getDigibankReport(): Promise<void> {
		await this.statisticProvider.getDigibankReport();
		this.messageService.showSavedMessage(
			translate('CLIENT.REPORT_DOWNLOADED', { email: this.userManager.getUserEmail() }),
			false
		);
	}

	public async getClientsExport(): Promise<void> {
		await this.provider.getClientsExport();
		this.messageService.showSavedMessage(translate('CLIENT.EXPORT_DOWNLOADED'));
	}

	public async openImportClients(): Promise<void> {
		this.navigationService
			.navigateTo<{ action: Action }>(NavigationType.page, '/clienten/importeren')
			.then((result) => {
				if (result?.action) {
					this.tableComponent?.refreshData();
					this.messageService.showSavedMessage(translate('CLIENTS_IMPORT.SUCCESS'));
				}
			})
			.catch();
	}

	public openMergeClients(): void {
		void this.navigationService
			.navigateTo<{ action: Action }>(NavigationType.page, '/clienten/samenvoegen')
			.then((result) => {
				if (result?.action) {
					this.tableComponent?.refreshData();
					this.messageService.showSavedMessage(translate('MERGE_CLIENTS.SUCCESS'));
				}
			})
			.catch();
	}

	public async openCreateClient(): Promise<void> {
		void this.navigationService
			.navigateTo<{ action: Action }>(NavigationType.modal, CreateClientComponent)
			.then((result) => {
				if (result?.action) {
					this.tableComponent?.refreshData();
					this.messageService.showSavedMessage(translate('CLIENT.CREATED'));
				}
			})
			.catch();
	}

	public async openClient(client: IClient): Promise<void> {
		void this.navigationService
			.navigateTo<{ action: Action }>(NavigationType.page, '/clienten/client', {
				client,
			})
			.then((result) => {
				if (result?.action) {
					this.tableComponent?.refreshData();
					this.messageService.showSavedMessage();
				}
			})
			.catch();
	}
}
